require('./angular-locale_he-il');
module.exports = 'ngLocale';



//////////////////
// WEBPACK FOOTER
// ./~/angular-i18n/he-il.js
// module id = 332
// module chunks = 0